import React, { Component } from 'react'
import { withStyles } from '@material-ui/core/styles'
import Select from '@material-ui/core/Select'
import InputLabel from '@material-ui/core/InputLabel'
import TextField from '@material-ui/core/TextField'
import MenuItem from '@material-ui/core/MenuItem'
import FormControl from '@material-ui/core/FormControl'

const styles = theme => ({
  root: {
    margin: '0 30px',
    display: 'flex',
    alignItems: 'center',
    borderBottom: `2px solid ${theme.borderColor}`
  },
  input: {
    width: 150,
    marginRight: 10
  }
})

class Drug extends Component {
  constructor (props) {
    super(props)
  }

  render () {
    const { treatments, doses, frequencies, units, number, onChange, classes } = this.props
    const { drug_id, dosage_value, dosage_units, frequency_value, frequency_units, unit } = this.props.values

    return (
      <div className={classes.root} style={Object.assign({}, styles)}>
        <FormControl className={classes.input}>
          <InputLabel>{`Drug ${number}`}</InputLabel>
          <Select
            value={drug_id}
            onChange={e => onChange(number, 'drug_id', e.target.value)}
          >
            { treatments.map(treatment => <MenuItem value={treatment.id}>{treatment.name}</MenuItem>) }
          </Select>
        </FormControl>
        <FormControl className={classes.input}>
          <TextField
            className={classes.input}
            label="Dosage Value"
            placeholder="Dosage Value"
            value={dosage_value}
            onChange={e => onChange(number, 'dosage_value', e.target.value)}
          />
        </FormControl>
        <FormControl className={classes.input}>
          <InputLabel>Unit</InputLabel>
          <Select
            value={dosage_units}
            onChange={e => onChange(number, 'dosage_units', e.target.value)}
          >
            { units.map(unit => <MenuItem value={unit}>{unit}</MenuItem>) }
          </Select>
        </FormControl>
        <FormControl className={classes.input}>
          <TextField
            className={classes.input}
            label="Frequency Value"
            placeholder="Frequency Value"
            value={frequency_value}
            onChange={e => onChange(number, 'frequency_value', e.target.value)}
          />
        </FormControl>
        <FormControl className={classes.input}>
          <InputLabel>Frequency</InputLabel>
          <Select
            value={frequency_units}
            onChange={e => onChange(number, 'frequency_units', e.target.value)}
          >
            { frequencies.map(frequency => <MenuItem value={frequency}>{frequency}</MenuItem>) }
          </Select>
        </FormControl>
      </div>
    )
  }
}

export default withStyles(styles)(Drug)



// WEBPACK FOOTER //
// ./src/components/TreatmentModal/Drug.js